import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { numberToCurrency } from 'utils/misc';
import { TextLink, InfoWidget, Table } from '@ds/react-components';

const styles = (theme) => ({
  root: {
    minWidth: '320px',
  },
  amountPayment: {
    color: theme.palette.common.black,
  },
  amountReversal: {
    color: theme.palette.common.red,
  },
  amountRefund: {
    color: theme.palette.common.secondary,
  },
  viewAllLink: {
    color: theme.palette.common.darkerText,
    '& path': {
      fill: theme.palette.common.darkerText,
    },
  },
  viewAllText: {
    fontSize: '12px',
  },
});

const tableMetadata = [
  {
    id: 'transDate',
    renderingField: 'transDateStr',
    width: '35%',
    numeric: false,
    disablePadding: false,
    alignment: 'left',
  },
  {
    id: 'transcode',
    renderingField: 'transcodeStr',
    width: '35%',
    numeric: false,
    hideInMobile: false,
    disablePadding: true,
    alignment: 'left',
  },
  {
    id: 'amount',
    renderingField: 'amountStr',
    width: '30%',
    numeric: true,
    hideInMobile: false,
    disablePadding: true,
    alignment: 'right',
  },
];

const getTransactionsForDisplay = (
  groupedTransactions,
  localisation,
  classes
) => {
  return groupedTransactions.map((tran) => {
    let transaction = { ...tran };
    const { dateFormat } = localisation.locales;
    transaction.transDateStr = moment(transaction.transDate).format(dateFormat);
    transaction.errorCodeStr =
      localisation.prompts.transErrorCode[transaction.errorCode];
    transaction.transcodeStr =
      transaction.errorCodeStr === ''
        ? transaction.isCombinedPayment
          ? 'Combined Payment...'
          : localisation.prompts.transactionCode[transaction.transcode]
        : 'Payment (' + transaction.errorCodeStr + ')';

    transaction.amountStr = (
      <Typography
        className={
          transaction.transcode === 'RF'
            ? classes.amountRefund
            : transaction.transcode === 'PF' || transaction.errorCodeStr !== ''
            ? classes.amountReversal
            : classes.amountPayment
        }>
        {numberToCurrency(Math.abs(transaction.totalAmount), localisation)}
      </Typography>
    );
    return transaction;
  });
};

class TransactionsPreview extends React.Component {
  render() {
    const { classes, customerDetails, localisation } = this.props;
    const { adfitNo, groupedTransactions } = customerDetails;
    const trans =
      groupedTransactions &&
      getTransactionsForDisplay(groupedTransactions, localisation, classes);
    return (
      <InfoWidget
        title="Recent Transactions"
        actionButton={
          <TextLink
            to={`/Transactions/${adfitNo}`}
            className={classes.viewAllLink}>
            <Typography variant="body2" className={classes.viewAllText}>
              {'View All'}
            </Typography>
            <ArrowForwardIcon fontSize={'small'} />
          </TextLink>
        }
        isLoading={!adfitNo || groupedTransactions == null}
        classes={{ root: classes.root }}>
        <Grid container>
          <Grid item xs={12}>
            <Table
              data={trans}
              metadata={tableMetadata}
              noBackground={true}
              enableSorting={false}
              showFooter={false}
            />
          </Grid>
        </Grid>
      </InfoWidget>
    );
  }
}

TransactionsPreview.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TransactionsPreview);
